


























































































































































































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

import { Status } from '@/enums/status'

/* eslint-disable */ 
import { User } from '../models/User'
import { Order } from '../models/Order'
import { OrderItem } from '../models/OrderItem'
import { DateTime } from 'luxon'
import { NetworkService } from '@/services/NetworkService'
/* eslint-enable */ 

export default Vue.extend({
  data () {
    return {
      headers: [
        {
          text: 'Date',
          sortable: false,
          align: 'start',
          value: 'updatedAt'
        },
        {
          text: 'Total Price',
          sortable: false,
          value: 'total'
        },
      ],
      adminHeaders: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Date',
          value: 'updatedAt'
        },
        {
          text: 'Total',
          value: 'total'
        },
        {
          text: 'Customer Name',
          value: 'name'
        },
      ],
      orderHeaders: [
        {
          text: 'Product Name',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Number',
          sortable: false,
          value: 'number'
        },
        {
          text: 'Price',
          sortable: false,
          value: 'price'
        },
        {
          text: 'Quantity',
          sortable: false,
          value: 'quantity'
        },
        {
          text: 'Options Charges',
          sortable: false,
          value: 'optionPrice'
        },
        {
          text: 'Item Total',
          sortable: false,
          value: 'total'
        }
      ],
      form: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
      },
      snackbarText: '',
      snackbar: false,
      selectedOrder: null as Order,
      orderDialog: false as boolean,
      emailDialog: false as boolean,
      adminTotals: { orders: 0, accessories: 0, value: 0 },
      dealershipTotals: { orders: 0, accessories: 0, value: 0 },
      window: window,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      isProductAdvisor: 'auth/isProductAdvisor',
      currentUser: 'auth/currentUser',
      currentDealer: 'dealers/currentDealer'
    }),
    obs() : any {
      return this.$refs.observer as any
    },
    orders() : Order[] {
      return this.currentUser != null ? this.currentUser.orders.filter(this.isOrder) : []
    },
    adminOrders() : Order[] {
      return this.isProductAdvisor ? this.currentUser.ordersPlaced : []
    },
    cols(): number {
      const { xs } = this.$vuetify.breakpoint
      return xs ? 1 : 3
    },
    isMobile() : boolean {
      const { xs } = this.$vuetify.breakpoint
      return xs
    },
  },
  methods: {
    ...mapActions({
      updateUserAction: 'auth/updateUser'
    }),
     async submit () {
       this.loading = false
       const isValid = await this.obs.validate()
       if (isValid) {
          const response = await this.updateUserAction(this.form)
          if (response === 200) {
            this.loading = false
            this.snackbarText = 'Your account information has been successfully updated.'
            this.snackbar = true
          } else {
            this.loading = false
            this.snackbarText = 'There was an error while updating your account. Please ensure the information is correct and that you are not already using the given e-mail.'
            this.snackbar = true
          }
       }
    },
    updateOrderNotes() {
      Order.updateOrder(this.selectedOrder)
    },
    isOrder(order: Order) : boolean {
      return order.statusId == Status.ORDER || order.statusId == Status.FULFILLED
    },
    async emailOrder(customer: boolean) : Promise<object> {
      this.loading = true
      const order : any = this.selectedOrder
      const res = await NetworkService.get(
        process.env.VUE_APP_API_BASE_URL +
        '/api/v1/auth/mail/order_summary?dealer=' + this.currentDealer.id + '&order=' + order.id + '&customer=' + customer
      )
      if (res.data.success == true) {
        this.snackbarText = 'E-mail successfully sent.'
      } else {
        this.snackbarText = 'There was an error sending the e-mail. Please wait a moment and try again.'
      }
      this.snackbar = true
      this.loading = false
      this.emailDialog = false
      return res
    },
    parseDateTime(time: string) : string {
      const date = DateTime.fromISO(time)
      return date.toLocaleString({ month: 'long', day: 'numeric' }) + ', ' + date.year
    },
    viewOrder(order: Order) : void {
      this.selectedOrder = order
      this.orderDialog = true
    },
    openEmailDialog(order: Order) : void {
      this.selectedOrder = order
      this.emailDialog = true
    },
    price(item: OrderItem) {
      return item.installed ? item.installedPrice : item.price
    },
    async getDealershipStats() {
      const today = new Date()
      const startOfMonthString = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().substr(0,10)
      const endOfMonthString = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().substr(0,10)

      const res = await Order.getOrders(null, this.currentDealer.id, startOfMonthString, endOfMonthString)
      return res.filter((order: Order) => order.statusId == Status.ORDER)
    },
    async setDealershipAndAdvisorStats() {
      const dealerOrders = await this.getDealershipStats()

      dealerOrders.forEach((order: Order) => {
        this.dealershipTotals.orders += 1
        this.dealershipTotals.accessories += order.orderItems.length
        this.dealershipTotals.value += order.subtotal
      })

      this.adminOrders.forEach((order: Order) => {
        this.adminTotals.orders = this.adminTotals.orders + 1
        this.adminTotals.accessories += order.orderItems.length
        this.adminTotals.value += order.subtotal
     })
    }
  },
  async mounted() {
    const res = await User.getUserById(this.currentUser.id)
    await this.$store.dispatch('auth/updateCurrentUser', res)
    this.form.firstName = this.currentUser.firstName
    this.form.lastName = this.currentUser.lastName
    this.form.email = this.currentUser.email
    this.form.phoneNumber = this.currentUser.phoneNumber

    if (this.isProductAdvisor) {
      this.setDealershipAndAdvisorStats()
    }
  }
})
